import { ExperimentStore } from 'bernie-core';

import { HotelResultsViewModel } from 'models';
import { FullPropertySearch, PropertySearch } from '__generated__/api';
import { OperationResult } from '__generated__/api/api-operations';

import { MigrationExperimentMapping, SearchMigrationAdapter } from 'stores/adapters/bex-api/migration-adapters';
import { Context } from 'bernie-context';
import { PageData } from 'bernie-http';

export const searchMigrationAdaptorExecutor = (
  context: Context,
  pageData: PageData,
  searchMigrationAdapters: SearchMigrationAdapter[],
  searchMigrationExperimentMapping: MigrationExperimentMapping,
  experiments: ExperimentStore,
  bffResults: HotelResultsViewModel,
  bexApiResults: OperationResult<PropertySearch.Query> | OperationResult<FullPropertySearch.Query>
): HotelResultsViewModel => {
  if (!bexApiResults) {
    return bffResults;
  }

  let propertySearchResults: HotelResultsViewModel = { ...bffResults };

  // Run migrated adapters.
  searchMigrationAdapters.forEach(adapter => {
    propertySearchResults = adapter(bffResults, bexApiResults);
  });

  if (!searchMigrationExperimentMapping) {
    return propertySearchResults;
  }

  // Run experimental adapters.
  Object.keys(searchMigrationExperimentMapping).forEach(key => {
    const exposure = experiments.exposures[key];

    // Comment out if without experiment.
    if (!exposure) {
      return;
    }

    experiments.logExperiment(context, pageData, exposure);

    if (exposure.bucket !== 1) {
      return;
    }

    propertySearchResults = searchMigrationExperimentMapping[key](propertySearchResults, bexApiResults);
  });

  return propertySearchResults;
};
